var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h2',[_vm._v("403 Forbidden")]),_c('p',[_vm._v("You don't have rights to access this page.")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to Home")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }